import { InputHTMLAttributes } from "react";

import { useFormContext } from "react-hook-form";

import { FormTitleType, LoginFormType } from "@domains/auth/types/authTypes";

import * as S from "./FormInput.style";

interface FormInputProps extends InputHTMLAttributes<HTMLInputElement> {
  formId: LoginFormType;
  label: FormTitleType;
}

const FormInput = ({ formId, label, ...rest }: FormInputProps) => {
  const { register, formState } = useFormContext();

  const errorMessage = () => {
    const { errors } = formState;

    return errors?.[formId] ? (errors?.[formId]?.message as string) : null;
  };

  return (
    <S.Container>
      <S.Title>{label}</S.Title>
      <S.Input
        id={formId}
        $isError={errorMessage()}
        {...register(formId)}
        {...rest}
      />
      {errorMessage() ? (
        <S.ErrorMessage>{errorMessage()}</S.ErrorMessage>
      ) : null}
    </S.Container>
  );
};

export default FormInput;
